import { jsx } from 'react/jsx-runtime';
import { mergeStyleSets, CommandBarButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useHydration } from '@agoras/hooks';
import { useContext, useMemo } from 'react';
import logger from '@agoras/logger';
import { AppContext } from '../../../../context/context.esm.js';
import { headerContext } from '../../../context.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var AI_FILTERS = [
    {
        urlGroup: 'category',
        urlKey: 'ai-apps-and-agents'
    },
    {
        urlGroup: 'filters',
        urlKey: 'Copilot-extension'
    }
];
var classNames = mergeStyleSets({
    button: {
        height: '100%'
    }
});
var AIAppsButton = function(param) {
    var filters = param.filters, _param_currentView = param.currentView, currentView = _param_currentView === void 0 ? '' : _param_currentView;
    var t = useTranslation('header').t;
    var isHydrated = useHydration();
    var navigate = useContext(AppContext).navigate;
    var text = t('AI Apps and Agents');
    var isActive = useMemo(function() {
        if (filters.length !== 1 || currentView !== 'appGallery') return false;
        var filter = filters[0];
        return AI_FILTERS.some(function(activeFilter) {
            return filter.UrlGroup === activeFilter.urlGroup && filter.UrlKey === activeFilter.urlKey;
        });
    }, [
        filters,
        currentView
    ]);
    var handleClick = function() {
        logger.info('', _object_spread({
            action: 'AIAppsAndAgentsButton',
            actionModifier: 'Click'
        }, headerContext));
        navigate({
            type: 'App',
            query: {
                category: 'ai-apps-and-agents'
            }
        });
    };
    return /*#__PURE__*/ jsx(CommandBarButton, {
        ariaLabel: text,
        text: text,
        onClick: handleClick,
        className: classNames.button,
        disabled: !isHydrated,
        checked: isActive
    });
};

export { AIAppsButton as default };
